<!-- profile-search></profile-search -->
<div class="profiles" *ngIf="CanAdminister(); else notAdmin">
  <div *ngFor="let profile of profiles"
       class="profile_row"
      [class.selected]="profile === currentTopic"
      [style.background-color]="this.getColorFor(profile)"
      (click)="gotoDetail(profile)">
    <div class="badge" *ngIf="!!profile.social && !!profile.social.picture"><img src="{{profile.social.picture}}"></div>
    <div class="details">
      <span class="name">{{profile.social.name}}</span>
      <span class="email">{{profile.social.email}}</span>
      <span class="rights">
        <div *ngIf="!!profile.review">review</div>
        <div *ngIf="!!profile.administer">administer</div>
      </span>
    </div>
  </div>
</div>
<ng-template #notAdmin>Not an administrator.</ng-template>
